/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import flowActions from 'loraactions/flow';
import ShowIf from 'loracoms/ShowIf';
import PageLoading from 'loracoms/PageLoading';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Flow from '../Flow';
import styles from './styles.scss';

const propTypes = {
  appId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.object.isRequired,
  flowsState: React.PropTypes.object.isRequired,
  getFlows: React.PropTypes.func.isRequired,
};

class Flows extends React.Component {
  constructor(props) {
    super(props);
    const { data: { flows = [] } = {} } = props.flowsState;
    this.state = {
      flows,
      flowsState: props.flowsState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.flowsview.flows');
  }

  componentWillMount() {
    const { appId, getFlows } = this.props;
    getFlows(appId);
  }

  componentWillReceiveProps(nextProps) {
    const { flowsState } = nextProps;
    if (flowsState !== this.props.flowsState) {
      this.setState({ flowsState });
      if (flowsState.status === 'success') {
        this.setState({ flows: flowsState.data.list });
      }
    }
  }

  render() {
    const { appId } = this.props;
    const { flowsState, flows } = this.state;
    if (flowsState.status === 'pending') {
      return <PageLoading />;
    }
    flows.sort((flowA, flowB) => flowA.name > flowB.name ? 1 : (flowA.name < flowB.name ? -1 : 0))
    return (
      <div>
        <div className={styles.flows}>
          {flows.map(flow => <Flow key={flow.id} flow={flow} appId={appId} />)}
        </div>
        <ShowIf if={flows.length === 0}>
          <div className={styles.noflow}>
            <h3>
              {this.intlMsg.msg('noflow')}
            </h3>
            <div className={styles.desc}>
              {this.intlMsg.msg('desc')}
            </div>
          </div>
        </ShowIf>
      </div>
    );
  }
}

Flows.propTypes = propTypes;

const mapStateToProps = state => ({
  flowsState: state.flow.getFlows,
});

const mapDispatchToProps = {
  getFlows: flowActions.getFlows,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Flows));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/Flows/index.jsx